import { gql } from "@apollo/client"

export const CREATE_TEACHER = gql`
  mutation createTeacher($data: TeacherCreateInput!) {
    educator {
      createTeacher(data: $data)
    }
  }
`

export const UPDATE_TEACHER = gql`
  mutation updateTeacher($data: TeacherUpdateInput!) {
    educator {
      updateTeacher(data: $data)
    }
  }
`

export const DELETE_TEACHERS = gql`
  mutation deleteTeachers($data: TeacherIdsListInput) {
    educator {
      removeBatch(data: $data)
    }
  }
`
